// Service pour gérer les applications
import authService from './authService';

const API_BASE = '/api';

class AppService {
  // Récupérer toutes les applications
  async getApplications() {
    try {
      const response = await fetch(`${API_BASE}/applications`, {
        headers: authService.getAuthHeaders(),
      });

      if (response.ok) {
        return await response.json();
      } else {
        throw new Error('Erreur lors de la récupération des applications');
      }
    } catch (error) {
      console.error('Erreur:', error);
      return [];
    }
  }

  // Récupérer une application par ID
  async getApplication(id) {
    try {
      const response = await fetch(`${API_BASE}/applications/${id}`, {
        headers: authService.getAuthHeaders(),
      });

      if (response.ok) {
        return await response.json();
      } else {
        return null;
      }
    } catch (error) {
      console.error('Erreur:', error);
      return null;
    }
  }

  // Ajouter une nouvelle application
  async addApplication(appData) {
    try {
      const response = await fetch(`${API_BASE}/applications`, {
        method: 'POST',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify(appData),
      });

      if (response.ok) {
        return await response.json();
      } else {
        const error = await response.json();
        throw new Error(error.error || 'Erreur lors de l\'ajout de l\'application');
      }
    } catch (error) {
      console.error('Erreur:', error);
      throw error;
    }
  }

  // Mettre à jour une application
  async updateApplication(id, appData) {
    try {
      const response = await fetch(`${API_BASE}/applications/${id}`, {
        method: 'PUT',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify(appData),
      });

      if (response.ok) {
        return await response.json();
      } else {
        const error = await response.json();
        throw new Error(error.error || 'Erreur lors de la mise à jour de l\'application');
      }
    } catch (error) {
      console.error('Erreur:', error);
      throw error;
    }
  }

  // Supprimer une application
  async deleteApplication(id) {
    try {
      const response = await fetch(`${API_BASE}/applications/${id}`, {
        method: 'DELETE',
        headers: authService.getAuthHeaders(),
      });

      if (response.ok) {
        return true;
      } else {
        const error = await response.json();
        throw new Error(error.error || 'Erreur lors de la suppression de l\'application');
      }
    } catch (error) {
      console.error('Erreur:', error);
      throw error;
    }
  }

  // Ouvrir une application avec authentification
  async openApp(appId) {
    try {
      // Récupérer d'abord l'URL de redirection avec le token
      const response = await fetch(`${API_BASE}/apps/${appId}/redirect-url`, {
        method: 'POST',
        headers: authService.getAuthHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        // Ouvrir l'URL avec le token inclus
        window.open(data.redirectUrl, '_blank');
      } else {
        console.error('Erreur lors de l\'ouverture de l\'application');
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  }
}

export default new AppService();
